// extracted by mini-css-extract-plugin
export default {"articles__wrapper":"Articles_articles__wrapper__tgULQ"};